import { __assign as v } from "../../../tslib/tslib.es6.js";
function a(u) {
  return u;
}
function s(u, r) {
  r === void 0 && (r = a);
  var n = [], o = !1, d = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : u;
    },
    useMedium: function(t) {
      var e = r(t, o);
      return n.push(e), function() {
        n = n.filter(function(i) {
          return i !== e;
        });
      };
    },
    assignSyncMedium: function(t) {
      for (o = !0; n.length; ) {
        var e = n;
        n = [], e.forEach(t);
      }
      n = {
        push: function(i) {
          return t(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(t) {
      o = !0;
      var e = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(t), e = n;
      }
      var h = function() {
        var f = e;
        e = [], f.forEach(t);
      }, c = function() {
        return Promise.resolve().then(h);
      };
      c(), n = {
        push: function(f) {
          e.push(f), c();
        },
        filter: function(f) {
          return e = e.filter(f), n;
        }
      };
    }
  };
  return d;
}
function m(u, r) {
  return r === void 0 && (r = a), s(u, r);
}
function g(u) {
  u === void 0 && (u = {});
  var r = s(null);
  return r.options = v({ async: !0, ssr: !1 }, u), r;
}
export {
  m as createMedium,
  g as createSidecarMedium
};
